export function buildCSSFormGroupInput(event, formGroupId, formGroupErrorId, isEmailValid) {
    buildCSSFormGroupInputTarget(event.target, formGroupId, formGroupErrorId, isEmailValid);
}

export function buildCSSFormGroupInputTarget(target, formGroupId, formGroupErrorId, isEmailValid) {
    // to be called on register page as well for email input
    let formGroup = document.getElementById(formGroupId);
    let formGroupError = document.getElementById(formGroupErrorId);
    let errorHeight = formGroupError.scrollHeight;
    errorHeight = isEmailValid ?  0 : (errorHeight + 10);
    target.style.marginBottom = `${errorHeight}px`;
    if (!isEmailValid)
        formGroup.classList.add("form__group--notvalid");
    else
        formGroup.classList.remove("form__group--notvalid");
}

export function getTextPixelWidth(text, fontFamily, fontWeight, fontSize) {
    const textEl = document.createElement("span");
    textEl.style.fontFamily = fontFamily;
    textEl.style.fontWeight = fontWeight;
    textEl.style.fontSize = fontSize;
    textEl.style.height = 'auto';
    textEl.style.width = 'auto';
    textEl.style.position = 'absolute';
    textEl.style.whiteSpace = 'no-wrap';
    textEl.innerHTML = text;

    document.body.appendChild(textEl);
    const width = Math.ceil(textEl.clientWidth);
    document.body.removeChild(textEl);

    return `${width}px`;
}
